import { IsNotEmpty } from 'main/common/validation/decorators/IsNotEmpty'
import { FormModel } from 'main/common/form-state-manager/FormModel'
import { IsOptional } from 'class-validator'

export class TreatmentFormModel extends FormModel {

    @IsNotEmpty()
    name: string

    @IsOptional()
    minDaysBetweenSessions?: number

    @IsNotEmpty()
    groupCodes: number[]

    @IsOptional()
    formCode: number

    constructor(initialData?: any) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
